import { Link } from 'react-router-dom';
import { FiLock } from 'react-icons/fi';
import { useAuth } from '@/hooks/useAuth';
import { UserRole } from '@/types';
import { PRODUCT_BY_ID, type ProductId } from '@/config/products';
import { isOrgAdminRole, ORG_PRODUCTS_PATH } from '@/utils/orgConsole';

interface NoProductLicenseProps {
  productId: ProductId;
}

export default function NoProductLicense({ productId }: NoProductLicenseProps) {
  const { user } = useAuth();
  const product = PRODUCT_BY_ID[productId];
  const isOrgAdmin = isOrgAdminRole(user?.role);

  return (
    <div className="h-full flex flex-col items-center justify-center px-6 py-12 text-center bg-bg">
      <div className="max-w-md rounded-xl border border-border bg-surface p-8 shadow-sm">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-amber-50 text-amber-700">
          <FiLock className="h-5 w-5" />
        </div>
        <h2 className="text-base font-bold text-text-primary">No CoTaskr license assigned</h2>
        <p className="mt-2 text-sm text-text-muted leading-relaxed">
          You are signed in to CoTaskr, but you do not have a license for{' '}
          <strong className="text-text-secondary">{product.name}</strong> yet.
          {isOrgAdmin
            ? ' Enable the product for your organization and assign yourself a seat from the org admin console.'
            : ' Ask your organization admin to assign you a CoTaskr product license.'}
        </p>
        <p className="mt-2 text-[11px] text-text-muted">CoTaskr is built by AiLenc.</p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          {isOrgAdmin ? (
            <Link
              to={ORG_PRODUCTS_PATH}
              className="inline-flex items-center rounded-lg bg-brand px-3 py-1.5 text-xs font-semibold text-white hover:opacity-95 transition-opacity"
            >
              Manage products &amp; licenses
            </Link>
          ) : (
            <Link
              to="/settings"
              className="inline-flex items-center rounded-lg border border-border px-3 py-1.5 text-xs font-semibold text-text-secondary hover:bg-surface-hover transition-colors"
            >
              Account settings
            </Link>
          )}
          {user?.role !== UserRole.SUPER_ADMIN && isOrgAdmin && (
            <Link
              to={ORG_PRODUCTS_PATH}
              className="inline-flex items-center rounded-lg border border-border px-3 py-1.5 text-xs font-semibold text-text-secondary hover:bg-surface-hover transition-colors"
            >
              Back to org admin
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
